import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProductDto } from "@/types/api/api-types";
import { WineColorEnum } from "@/constants/enums/wineColor.enum";

export const getProductColumns = (
  t: TFunction<"boCatalog">,
  onEdit: (product: ProductDto) => void,
  onDelete: (product: ProductDto) => void,
  wineColorLabels: Record<WineColorEnum, string>,
): ColumnDef<ProductDto>[] => [
  {
    accessorKey: "description",
    header: t("productsTable.columns.description"),
    cell: (info) => (
      <span className="text-base font-medium text-gray-900">{info.row.original.description}</span>
    ),
  },
  {
    accessorKey: "descriptionPelican",
    header: t("productsTable.columns.descriptionPelican"),
    cell: (info) => (
      <span className="text-sm text-gray-600">{info.row.original.descriptionPelican}</span>
    ),
  },
  {
    accessorKey: "countryOfOrigin",
    header: t("productsTable.columns.countryOfOrigin"),
    enableSorting: false,
    cell: (info) => (
      <span className="text-sm text-gray-600">{info.row.original.countryOfOrigin}</span>
    ),
  },
  {
    accessorKey: "harmonizedCode",
    header: t("productsTable.columns.harmonizedCode"),
    enableSorting: false,
    cell: (info) => (
      <span className="text-sm text-gray-600">{info.row.original.harmonizedCode}</span>
    ),
  },
  {
    accessorKey: "color",
    header: t("productsTable.columns.color"),
    enableSorting: false,
    cell: (info) => (
      <span className="text-sm text-gray-600">
        {wineColorLabels[info.row.original.color as WineColorEnum] || info.row.original.color}
      </span>
    ),
  },
  {
    id: "actions",
    header: "",
    enableSorting: false,
    cell: (info) => (
      <div className="flex flex-row gap-1">
        <Button variant="ghost" size="sm" onClick={() => onEdit(info.row.original)}>
          <Pencil className="h-4 w-4 text-gray-500" />
        </Button>
        <Button variant="ghost" size="sm" onClick={() => onDelete(info.row.original)}>
          <Trash2 className="h-4 w-4 text-red-500" />
        </Button>
      </div>
    ),
  },
];
